export default __webpack_public_path__ + "static/media/my_team_insights_theme_upload.7f18e96e.gif";